export default "__VITE_ASSET__COKqvRNb__"